<div class="d-flex align-items-start">
  <div class="col-5 asset-card-content-title">{{ attributeValue.name }}</div>
  <div class="col-7 asset-card-content-value text-break">
    <ng-container *ngIf="attributeValue.selectedOptions?.length; else noValue">
      {{ attributeValue.selectedOptions?.join(', ') }}
    </ng-container>
    <ng-template #noValue>
      {{ attributeValue.selectedOptions | hasValue }}
    </ng-template>
  </div>
</div>
